<div [ngClass]="group.layout" class="coverage-radio">
    <div class="vertical-explanation">
        <label>&nbsp;</label>
        <div class="vertical-explanation__items" *ngIf="coverageVehicleData.descriptions[group.productId]">
            <div class="vertical-explanation__text">Premie per maand</div>
            <div
                class="vertical-explanation__text"
                *ngFor="let description of coverageVehicleData.descriptions[group.productId]"
            >
                {{ description.label }}
            </div>
        </div>
    </div>
    <ng-container *ngFor="let input of group.inputs">
        <div
            class="vertical__column"
            (click)="setSelected(input)"
            [class.active]="active"
            id="radio-{{ id }}-{{ input.id }}"
        >
            <div
                [class.vertical__column--disabled]="!input.acceptance"
                [class.vertical__column--active]="selectedIndex === input.id"
                [class.vertical__column--not-active]="selectedIndex !== input.id"
                [insTooltip]="!input.acceptance ? 'Deze dekking is niet mogelijk in uw situatie' : ''"
            >
                <div class="vertical__nudge vertical__nudge-desktop" *ngIf="input.mostPopular">
                    <span>Meest gekozen</span>
                </div>
                <label for="radio-{{ id }}-{{ input.id }}">
                    <input
                        type="radio"
                        [(ngModel)]="value.choice"
                        [name]="group.id"
                        id="radio-{{ id }}-{{ input.id }}"
                        [value]="input.id"
                        [checked]="selectedIndex === input.id"
                        (change)="propagateChange()"
                        [disabled]="!input.acceptance"
                        class="radio vertical-description-mobile"
                    />
                    <span class="vertical-description-desktop">{{ input?.data?.title }}</span>
                    <div class="vertical__nudge vertical__nudge-mobile" *ngIf="input.mostPopular">
                        <span>Meest gekozen</span>
                    </div>
                </label>
                <div class="vertical__price-wrapper">
                    <a href="" (click)="openModal(input)">
                        <svg class="svg-icon svg-icon--xs"><use href="assets/icons-ui.svg#informatie"></use></svg>
                        meer info
                    </a>
                    <span class="vertical__price" [ins-decimallize]="input.price"></span>
                </div>
                <div class="vertical__items" *ngIf="coverageVehicleData.options[input.id]">
                    <div class="vertical__item" *ngFor="let option of coverageVehicleData.options[input.id].options">
                        <span *ngIf="option.type === 'boolean'">
                            <svg *ngIf="option.value" class="svg-icon svg-icon--xs">
                                <use href="assets/icons-ui.svg#check-closed"></use>
                            </svg>
                            <svg *ngIf="!option.value" class="svg-icon svg-icon--xs svg-icon--secondary">
                                <use href="assets/icons-ui.svg#cross-closed"></use>
                            </svg>
                        </span>
                        <span *ngIf="option.type === 'string'">{{ option.value }}</span>
                    </div>
                    <div class="vertical__item-bottom">
                        <div>
                            <button class="btn btn--primary" type="button" *ngIf="selectedIndex !== input.id">
                                Kies
                            </button>
                            <button
                                *ngIf="selectedIndex === input.id"
                                class="btn btn--primary btn-active vertical__item-bottom-active vertical__item-bottom-chosen"
                            >
                                gekozen
                            </button>
                        </div>
                        <wuc-link type="secondary" (click)="openModal(input)">Meer info</wuc-link>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</div>
